import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/layout/ScrollToTop';
import HomePage from './components/pages/HomePage';
import AboutPage from './components/pages/AboutPage';
import ContactPage from './components/pages/ContactPage';
import DestinationsPage from './components/pages/DestinationsPage';
import DestinationDetailPage from './components/pages/DestinationDetailPage';
import PackagesPage from './components/pages/PackagesPage';
import PackageDetailPage from './components/pages/PackageDetailPage';
import GalleryPage from './components/pages/GalleryPage';
import './App.css';

// Wrapper component to conditionally apply the background color
function PageWrapper({ children }) {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  return (
    <div className={!isHomePage ? 'page-background' : ''}>
      {children}
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={
              <PageWrapper>
                <AboutPage />
              </PageWrapper>
            } />
            <Route path="/contact" element={
              <PageWrapper>
                <ContactPage />
              </PageWrapper>
            } />
            <Route path="/destinations" element={
              <PageWrapper>
                <DestinationsPage />
              </PageWrapper>
            } />
            <Route path="/gallery" element={
              <PageWrapper>
                <GalleryPage />
              </PageWrapper>
            } />
            <Route path="/destinations/:id" element={
              <PageWrapper>
                <DestinationDetailPage />
              </PageWrapper>
            } />
            <Route path="/packages" element={
              <PageWrapper>
                <PackagesPage />
              </PageWrapper>
            } />
            <Route path="/packages/:id" element={
              <PageWrapper>
                <PackageDetailPage />
              </PageWrapper>
            } />
            {/* Additional routes will be added for other pages */}
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
